<template>
  <div>
    <b-modal
      footer="{null}"
      centered
      id="sim_card_gmcvs_block"
      title="Bloquer ma SIM"
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
    >
      <div>
        <div v-if="!is_ok">
          <div class="modal-header-wrap text-center">
            <i class="kgk-mtn-app_blocking modal-header-icon yellow-muted"></i>
            <h3>Bloquer ma SIM</h3>
            <p class="text-muted">
              Vous avez été victime d'un vol et vous souhaitez protéger votre
              compte? Bloquez votre carte SIM pour éviter qu'une tierce personne
              ne l'utilise.<br />Cliquez sur le bouton ci dessous pour le
              bloquer.
            </p>
          </div>

          <div class="mt-3 mb-3 text-center">
            <button @click="go()" class="btn btn-primary">
              <b-spinner small v-if="is_loading" label="Loading..."></b-spinner>
              <span v-if="!is_loading">Bloquer ma SIM</span>
            </button>
          </div>
        </div>

        <div v-if="is_ok" class="text-center">
          <i
            class="kgk-mtn-app_blocking modal-main-icon"
            style="color: #31a705"
          ></i>
          <p class="mt-3 mb-3">
            Votre carte SIM a été bloquée avec succès. Votre numéro est passé
            hors ligne.
          </p>
        </div>
      </div>
      <div></div>
    </b-modal>
  </div>
</template>

<script>
import { subscriber } from "@/services/";
export default {
  name: "SimCardBlock",
  mounted: async function () {},
  data: () => {
    return {
      is_ok: false,
      is_loading: false,
    };
  },
  methods: {
    go: async function () {
      if (!confirm(this.utils_get_config_message("block_sim_prevent"))) {
        return;
      }
      this.is_loading = true;
      var response = await subscriber.gmcvs("gmcvs_block");
      if (!_.isUndefined(response.blocked)) {
        this.is_ok = true;
      }
      this.is_loading = false;
    },
  },
};
</script>
<style scoped lang="css">
#puk_details {
  font-weight: bold;
  font-size: 22px;
  letter-spacing: 2px;
}
</style>